type IProps = {
  name: string;
  score: string;
  emoji: any;
  direction?: string;
};

const MiniCard: React.FC<IProps> = ({ name, score, emoji, direction }) => {
  return (
    <div
      className={`bg-white rounded-lg shadow-lg m-1 ${
        direction === "col"
          ? "flexCenter flex-col space-y-2 p-1 flex-1"
          : "flexCenter space-x-3 w-full p-4 "
      }`}
    >
      <div
        className={`rounded-2xl bg-gray-100 ${
          direction === "col" ? "py-5 px-10" : "p-5"
        }`}
      >
        <img src={emoji} alt="emoji" width={30} height={30} />
      </div>

      <div
        className={`flex flex-col ${direction === "col" ? "items-center" : ""}`}
      >
        <span className="card-title">{score}</span>
        <span className="card-subtitle">{name}</span>
      </div>
    </div>
  );
};

export default MiniCard;
